module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/features/headers-styles/header-style5/header-style5.component.scss
// module id = ./src/app/features/headers-styles/header-style5/header-style5.component.scss
// module chunks = main